<template>
  <!-- <TransitionWrapper name="slideHorizontal"> -->
  <div
    v-if="isOpen"
    v-focus-trap="isOpen"
    v-hotkey="keymap"
    class="flyout"
  >
    <div class="flyoutHeader">
      <slot name="title" />

      <ButtonClose @click="handleClose" />
    </div>

    <div
      ref="flyoutBody"
      class="flyoutBody"
    >
      <slot name="body" />
    </div>
  </div>
  <!-- </TransitionWrapper> -->
</template>

<script>
import { ButtonClose, focusTrap /* , TransitionWrapper */ } from '@jumpcloud/ui-components';
import { tabbable } from 'tabbable';

/**
 * @todo Uncomment TransitionWrapper code when new transition is available
 */

export default {
  name: 'Flyout',

  components: {
    ButtonClose,
    // TransitionWrapper,
  },

  emits: ['close'],

  directives: {
    focusTrap,
  },

  props: {
    isOpen: Boolean,
  },

  computed: {
    keymap() {
      return {
        esc: this.handleClose,
      };
    },
  },

  watch: {
    isOpen(open) {
      if (open) {
        this.focusFirstTabbable();
      }
    },
  },

  mounted() {
    if (this.isOpen) {
      this.focusFirstTabbable();
    }
  },

  methods: {
    focusFirstTabbable() {
      this.$nextTick(() => {
        const tabbables = tabbable(this.$refs.flyoutBody);

        if (tabbables?.length > 0) {
          tabbables[0].focus();
        }
      });
    },

    handleClose() {
      this.$emit('close');
    },
  },
};
</script>

<style scoped>
.flyout {
  background: var(--jcWhite50);
  border: 1px solid var(--jc-color-neutral-stroke);
  border-bottom-left-radius: var(--jc-border-radius-large);
  border-top-left-radius: var(--jc-border-radius-large);
  bottom: 0;
  box-shadow: var(--jc-box-shadow-large);
  display: flex;
  flex-direction: column;
  max-width: 100%;
  position: absolute;
  right: 0;
  top: -1px;
  width: 46rem;
  z-index: 1000;
}

.flyoutBody {
  overflow: auto;
}

.flyoutHeader {
  align-items: center;
  border-bottom: 1px solid var(--jc-color-neutral-stroke);
  display: flex;
  justify-content: space-between;
  padding: var(--jc-spacer-medium);
}

@media screen and (max-width: 768px) {
  .flyout {
    border-bottom-left-radius: 0;
    border-top-left-radius: 0;
  }

  .flyoutHeader {
    padding: var(--jc-size-0p75) var(--jc-spacer);
  }
}
</style>
